import { jsx as _jsx } from "react/jsx-runtime";
import { cssVar } from "@chakra-ui/theme-tools";
import { CrossIcon } from "@tempo/icons";
import { getRingStyle } from "./getRingStyle";
import { CloseButton } from "@chakra-ui/react";
const $size = cssVar('close-button-size');
const baseStyle = (props)=>{
    return {
        w: [
            $size.reference
        ],
        h: [
            $size.reference
        ],
        transitionProperty: 'common',
        transitionDuration: 'normal',
        _disabled: {
            opacity: 0.4,
            cursor: 'not-allowed',
            boxShadow: 'none'
        },
        _hover: {
            bg: 'blackAlpha.100',
            _dark: {
                bg: 'whiteAlpha.100'
            }
        },
        transform: 'perspective(1000px) translateZ(0px)',
        _active: {
            bg: 'blackAlpha.200',
            transform: 'perspective(1000px) translateZ(-50px)',
            _dark: {
                bg: 'whiteAlpha.200'
            }
        },
        _focus: getRingStyle('blackAlpha.200', props.borderRadius, 'whiteAlpha.200'),
        borderRadius: 'full',
        position: 'relative'
    };
};
const sizes = {
    lg: {
        [$size.variable]: '40px',
        fontSize: '16px'
    },
    md: {
        [$size.variable]: '32px',
        fontSize: '12px'
    },
    sm: {
        [$size.variable]: '24px',
        fontSize: '10px'
    }
};
const defaultProps = {
    size: 'md',
    children: /*#__PURE__*/ _jsx(CrossIcon, {
        width: "0.9em",
        height: "0.9em"
    })
};
CloseButton.defaultProps = defaultProps;
export { CloseButton };
export const ThemedCloseButton = {
    baseStyle,
    sizes,
    defaultProps
};

//# sourceMappingURL=CloseButton.js.map